module.exports = __webpack_public_path__ + "img/nl.34656d9c.svg";